// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"8ec5b240","124":"a61a0149","713":"1e149ce7","851":"506e5d9b"}[chunkId] + ".chunk.css";
};